import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cec1a4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Apply ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Filters")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Tracks")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "secondary" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "danger",
                  onClick: _ctx.handleCancel
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "primary" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "primary",
                  onClick: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { class: "f-normal" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-padding-horizontal" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "header f-normal black" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agenda, (item) => {
              return (_openBlock(), _createBlock(_component_ion_item, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ backgroundColor: item.colour }),
                    class: "agenda-color"
                  }, null, 4),
                  _createVNode(_component_ion_label, { class: "header f-normal black" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.sessionName || 'No Track'), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_checkbox, {
                    slot: "end",
                    onIonChange: ($event: any) => (_ctx.onDataCheckBoxChange(item, $event)),
                    "model-value": item.isChecked
                  }, null, 8, ["onIonChange", "model-value"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}